module.exports = __webpack_public_path__ + "img/right-arrow.70b5c7a6.png";